import React, { PropsWithChildren } from 'react';

import { Body } from '../Typography';

export const LabelSuffix: React.FC<PropsWithChildren<{ suffix?: string }>> = ({ children, suffix = 'Optional' }) => (
  <div className='flex items-center gap-4'>
    {children}
    <Body size='small' color='secondary' className='italic'>
      {suffix}
    </Body>
  </div>
);
